import styled from "styled-components";

export const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export const LoadingBox = styled.div`
  background: #ffffff;
  padding: 24px 32px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  min-width: 220px;
`;

export const LoadingSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #e5e5e5;
  border-top: 4px solid #7a2cff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const LoadingText = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #333;
`;

export const Title = styled.p`
  width: 100%;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 4px;
`;

export const Subtitle = styled.span`
  width: 100%;
  font-size: 15px;
  color: #8e8e8e;
  margin-bottom: 24px;
`;

export const InvoiceSummaryBox = styled.div`
  width: 100%;
  max-width: 600px;
  background: #fff;
  border: 1px solid #e9e9e9;
  border-radius: 16px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const SummaryColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ align }) => align || "flex-start"};
`;

export const BoxLabel = styled.span`
  font-size: 13px;
  color: #8e8e8e;
`;

export const BoxValue = styled.strong`
  font-size: 24px;
  font-weight: 700;
`;

export const StatusTags = styled.div`
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;

  background: ${({ status }) =>
    status === "PAGO" ? "#E6F9F0" :
      status === "ABERTA" ? "#FFF4E5" :
        status === "ATRASADA" ? "#FDEAEA" : "#F0F0F0"};

  color: ${({ status }) =>
    status === "PAGO" ? "#00A86B" :
      status === "ABERTA" ? "#FF8C00" :
        status === "ATRASADA" ? "#E71037" : "#666"};
`;

export const StatusDate = styled.span`
  font-size: 14px;
  color: #6f6f6f;
`;

export const InfoBoxesRow = styled.div`
  width: 100%;
  max-width: 600px;
  display: flex;
  gap: 12px;
  white-space: nowrap;
`;

export const InfoBox = styled.div`
  flex: 1;
  min-width: 0; 
  background: #fff;
  border: 1px solid #e9e9e9;
  border-radius: 16px;
  padding: 16px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  text-align: center;
`;

export const BoxValueSmall = styled.strong`
  font-size: 16px;
  font-weight: 700;
`;

export const BottomBoxesRow = styled.div`
  width: 100%;
  max-width: 600px;
  display: flex;
  gap: 12px;
  margin-top: 20px;
  align-items: stretch;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const PaidStatusBox = styled.div`
  width: 100%;
  max-width: 600px;
  background: #fff;
  border: 1px solid #d8f3e5;
  box-shadow: 0 3px 10px rgba(17, 24, 39, 0.06);
  border-radius: 16px;
  padding: 20px;
  margin-top: 20px;
  text-align: center;
`;

export const PaidStatusTitle = styled.strong`
  display: block;
  font-size: 18px;
  font-weight: 700;
  color: #00a86b;
  margin-bottom: 8px;
`;

export const PaidStatusText = styled.span`
  display: block;
  font-size: 14px;
  line-height: 22px;
  color: #6f6f6f;
`;

export const ParcelText = styled.span`
  width: 100%;
  font-size: 13px;
  line-height: 20px;
  color: #8e8e8e;
  margin-bottom: 16px;
  margin: 0;
`;

export const OptionCard = styled.div`
  display: flex;
  flex-direction: column;
  background: #f8f8f8;
  padding: 12px;
  border-radius: 10px;
  margin-top: 12px;
  justify-content: center;
  align-items: center;
`;

export const OptionLabel = styled.span`
  font-size: 12px;
  color: #8e8e8e;
`;

export const OptionValue = styled.strong`
  font-size: 14px;
`;

export const FooterButtons = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;
`;

export const SecondaryActionButton = styled.button`
  height: 44px;
  padding: 0 20px;
  border-radius: 10px;
  cursor: pointer;

  display: flex;  
  align-items: center; 
  justify-content: center; 
  gap: 8px;

  border: 1px solid ${({ variant }) =>
    variant === "danger" ? "#E71037" : "#d9d9d9"};

  background: ${({ variant }) =>
    variant === "danger" ? "#E71037" : "#fff"};

  color: ${({ variant }) =>
    variant === "danger" ? "#fff" : "#1f1f1f"};

  svg, img {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    display: block;
  }
`;

export const FixedBox = styled.div`
  flex: 1;
  min-width: 0;

  min-height: 180px;

  display: flex;
  flex-direction: column;
`;